import { PhraseFilterValue, PhraseValue, useSendPhrase } from 'hooks/business/usePhraseOnChat';
import ActivePopoverV2, { ActivePopoverV2Trigger } from '../../Phrase/ActivePopoverV2';
import NewActivePopover, {
  ActivePopoverV2Trigger as NewActivePopoverTrigger,
} from '../../Phrase/NewActivePopover';
import { useSetConversationInputDraft } from 'hooks/business/conversationDraft';
import { usePhraseSideModeValue } from '../../Phrase/state';
import { useOrgConfigStateValue } from 'hooks/business/useOrgConfig';

export interface PhrasePickerProps {
  conversation: Conversation.Conversation;
  phraseGroups: Phrase.Group[];
  phraseFilter?: PhraseFilterValue;
  phrasesByGroup: PhraseValue[];
  phraseList: PhraseValue[];
  // 与美客多对话窗口
  onMercadoChatView: boolean;
  updatePhraseFilter: (value: PhraseFilterValue) => void;
  onFillPhrasesText: (data: string) => void;
  onSend?: () => void;
}

export const PhrasePicker = (props: PhrasePickerProps) => {
  const { conversation, onMercadoChatView, onSend, ...otherProps } = props;

  const setInput = useSetConversationInputDraft();

  const sendPhraseV2 = useSendPhrase({ onSend }, onMercadoChatView);

  const sideMode = usePhraseSideModeValue();

  const { whiteListConfig: { NEW_PHRASE } = {} } = useOrgConfigStateValue();

  const OldComponent = sideMode ? ActivePopoverV2Trigger : ActivePopoverV2;
  const NewComponent = sideMode ? NewActivePopoverTrigger : NewActivePopover;
  const Component = NEW_PHRASE ? NewComponent : OldComponent;

  return (
    <Component
      {...otherProps}
      conversationId={conversation.conversationId}
      channel={conversation.channel}
      region={conversation.region}
      sendPhrase={sendPhraseV2}
      onSend={() => {
        setInput(conversation.conversationId, '');
      }}
    />
  );
};
